/* ============================================================
   SLIDESHOW ANIMATED BACKGROUND SWITCHER
   Cross-fades a slideshow's animated background layers as the slideshow
   advances. Each <slideshow-slide> carries data-slide-bg="<key>" (stamped by
   blocks/_slide.liquid); each layer carries data-bg-layer="<key>" (rendered by
   snippets/slideshow-backgrounds.liquid). This script keeps exactly one layer in
   data-bg-state="active" and mirrors the active key onto the section wrapper as
   data-active-bg, which the CSS uses to recolour the pagination dots.

   Notes on the two non-obvious choices here:
     · The key is read off event.detail.slide, never off detail.index. For
       non-adjacent and looping jumps assets/slideshow.js reorders the slides in
       the DOM and re-asserts `current` in a queueMicrotask AFTER the event fires,
       so an index is momentarily untrustworthy; the element reference is not.
     · There is deliberately no `userInitiated` filter (unlike
       assets/collection-links.js). Autoplay-driven changes report
       userInitiated: false and must still switch the background.
   ============================================================ */
(function () {
  'use strict';

  // snippets/slideshow-backgrounds.liquid emits this tag once per slideshow that
  // has backgrounds, so more than one copy can land on a page.
  if (window.__ellianosSlideshowBgSwitcher) return;
  window.__ellianosSlideshowBgSwitcher = true;

  var SECTION_SELECTOR = '[data-slideshow-bg]';

  /** The slideshow-component that a section owns directly (not one nested in a slide). */
  function ownComponent(section) {
    for (var el = section.firstElementChild; el; el = el.nextElementSibling) {
      if (el.tagName === 'SLIDESHOW-COMPONENT') return el;
    }
    return null;
  }

  function apply(slide) {
    if (!slide || !slide.closest) return;
    var component = slide.closest('slideshow-component');
    if (!component) return;

    // The section wrapper is the component's parent (snippets/slideshow.liquid
    // renders slideshow-component as a direct child of the section div). A
    // slideshow nested inside a slide fails this test and is ignored, so its
    // bubbling event cannot hijack the outer section's background.
    var section = component.parentElement;
    if (!section || !section.hasAttribute('data-slideshow-bg')) return;

    var key = slide.getAttribute('data-slide-bg') || 'none';
    if (section.getAttribute('data-active-bg') === key) return; // already there

    section.setAttribute('data-active-bg', key);

    var layers = section.querySelectorAll('.slideshow-bg > [data-bg-layer]');
    for (var i = 0; i < layers.length; i++) {
      layers[i].setAttribute(
        'data-bg-state',
        layers[i].getAttribute('data-bg-layer') === key ? 'active' : 'inactive'
      );
    }
  }

  /* Reconcile every slideshow on the page with its currently visible slide. The
     initial state is already correct from the server, so this is normally a no-op
     — it exists for theme-editor section reloads and for any case where a
     slideshow starts on a slide other than the first. */
  function syncAll() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      var component = ownComponent(sections[i]);
      if (!component) continue;
      var slides = component.querySelectorAll('slideshow-slide[aria-hidden="false"]');
      for (var j = 0; j < slides.length; j++) {
        if (slides[j].closest('slideshow-component') === component) {
          apply(slides[j]);
          break;
        }
      }
    }
  }

  document.addEventListener('slideshow:select', function (event) {
    if (event.detail) apply(event.detail.slide);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
  document.addEventListener('shopify:section:load', syncAll);
})();
